import { computed, ExtractPropTypes } from 'vue'
import { LlmToolCall } from '@/libs/features/llm/types'
import { formatToolCall, sortAndFilterCitations } from '../format'
import { AskAProfileTool } from '../types'
import { RESPONSE_CONTENT_PROPS } from './types'

type ResponseContentProps = ExtractPropTypes<typeof RESPONSE_CONTENT_PROPS>

/**
 *
 * @param props
 * @param props.sections
 * @param props.patientId
 * @param props.loading
 * @param props.showDevTools
 */
export default function (props: ResponseContentProps) {
  const sectionsWithCitations = computed(() =>
    props.sections.map((section) => ({
      ...section,
      sortedCitations: sortAndFilterCitations(
        section.response?.citations ?? []
      ),
      toolsToShow: (section.response?.tools ?? []).filter((tool: LlmToolCall) =>
        Object.values(AskAProfileTool).includes(
          tool.toolName as AskAProfileTool
        )
      ),
      showFeedback:
        !props.loading && !!section.response && !!section.loggingDetails,
    }))
  )

  return {
    sectionsWithCitations,
    formatToolCall,
  }
}
